import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider } from "./providers/ThemeProvider";
import ColorThemeProvider from "./components/ColorThemeProvider";
import { IS_STANDALONE } from "./lib/config";
import "./index.css";
import "./ai-assistant.css";

const ChatInterface = lazy(() => import("./components/ChatInterface"));

// For acetrials-frontend integration (exported as a page component)
// Only exports ChatInterface without providers - acetrials-frontend provides the layout
export default function AIAssistantPage() {
    // If not standalone, just render ChatInterface within acetrials-frontend's layout
    if (!IS_STANDALONE) {
        return (
            <ThemeProvider>
                <ColorThemeProvider>
                    <div
                        style={{ height: "calc(100vh - 120px)", width: "100%" }}
                    >
                        <Suspense
                            fallback={
                                <div className="flex items-center justify-center h-full">
                                    <div className="text-lg">
                                        Loading AI Assistant...
                                    </div>
                                </div>
                            }
                        >
                            <ChatInterface />
                        </Suspense>
                    </div>
                </ColorThemeProvider>
            </ThemeProvider>
        );
    }

    // For standalone mode, use full App
    return (
        <div className="h-full w-full">
            <App />
        </div>
    );
}

// For standalone React app (render to DOM)
// Only render if running as standalone app (not imported by acetrials-frontend)
if (typeof window !== "undefined" && IS_STANDALONE) {
    const rootElement = document.getElementById("root");
    if (rootElement) {
        const root = ReactDOM.createRoot(rootElement);
        root.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>,
        );
    }
}
